import { z } from "zod";

export const affectInspectorGateSchema = z.object({
  gateId: z.string().nullable(),
});

export const defaultAffectInspectorGateValues = {
  gateId: null,
};

export type AffectInspectorGateForm = z.infer<typeof affectInspectorGateSchema>;
